import {
  EdgeStyleIndicatorRenderer,
  HighlightIndicatorManager,
  IEdge,
  INode,
  IObjectRenderer,
  NodeStyleIndicatorRenderer,
  StyleIndicatorZoomPolicy,
} from '@ardoq/yfiles';
import { HoverEdgeStyle } from 'yfilesExtensions/view/modernized/HoverEdgeStyle';
import { DropzoneNodeStyle } from '../DropzoneNodeStyle';
import {
  HandleImageDropCallback,
  IsValidDropTargetCallback,
} from 'yfilesExtensions/view/modernized/types';
import { componentInterface } from '@ardoq/component-interface';
import { workspaceAccessControlInterface } from 'resourcePermissions/accessControlHelpers/workspace';
import { currentUserInterface } from 'modelInterface/currentUser/currentUserInterface';
import { getActiveScenarioState } from 'streams/activeScenario/activeScenario$';
import { dispatchAction } from '@ardoq/rxbeach';
import { imageDroppedOnComponentNode } from 'streams/components/ComponentActions';
import { ArdoqId } from '@ardoq/api-types';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';
import { getFeatureContext } from 'streams/featureContext$';
import { lockOperations } from 'lockedComponents/lockOperations';

export const defaultHandleImageDropCallback = (
  componentId: ArdoqId,
  file: File
) => {
  dispatchAction(imageDroppedOnComponentNode({ componentId, file }));
};

export const defaultIsValidDropTargetCallback = (node: INode): boolean => {
  const modelId = dataModelId(node.tag);
  if (!modelId) {
    return false;
  }
  const workspaceId = componentInterface.getWorkspaceId(modelId);
  return (
    !lockOperations.isLocked(
      componentInterface.get(modelId)?.lock,
      getFeatureContext()
    ) &&
    !!workspaceId &&
    workspaceAccessControlInterface.canEditWorkspace(
      currentUserInterface.getPermissionContext(),
      workspaceId,
      getActiveScenarioState()
    )
  );
};

class ModernizedHighlightIndicatorManager extends HighlightIndicatorManager<
  INode | IEdge
> {
  private readonly nodeHighlightRenderer: NodeStyleIndicatorRenderer;
  private readonly edgeHighlightRenderer = new EdgeStyleIndicatorRenderer({
    edgeStyle: new HoverEdgeStyle(),
    zoomPolicy: StyleIndicatorZoomPolicy.WORLD_COORDINATES,
  });

  constructor(
    public readonly handleImageDropCallback: HandleImageDropCallback | null,
    public readonly isValidDropTargetCallback: IsValidDropTargetCallback | null
  ) {
    super();
    this.nodeHighlightRenderer = new NodeStyleIndicatorRenderer({
      nodeStyle: new DropzoneNodeStyle(isValidDropTargetCallback),
      margins: DropzoneNodeStyle.MARGIN,
      zoomPolicy: StyleIndicatorZoomPolicy.WORLD_COORDINATES,
    });
  }

  protected override getRenderer(
    item: INode | IEdge
  ): IObjectRenderer<INode | IEdge> | null {
    if (item instanceof INode) {
      return this.nodeHighlightRenderer;
    }
    if (item instanceof IEdge) {
      return this.edgeHighlightRenderer;
    }
    return super.getRenderer(item);
  }
}
export { ModernizedHighlightIndicatorManager };
